import { Injectable } from '@angular/core';
import { UserInfo } from '@rd/types';
import { UserInfoResponse } from '@rd/types/user-info.response';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GuardhouseApiDataService } from '../guardhouse-api-data/guardhouse-api-data.service';

@Injectable({
  providedIn: 'root',
})
export class UserInfoApiService {
  constructor(private guardhouseApiDataService: GuardhouseApiDataService) {}

  getUserInfo(): Observable<UserInfo> {
    return this.guardhouseApiDataService.get<UserInfoResponse>('userinfo').pipe(
      map((userInfoResponse) => {
        return this.transformUserInfoResponse(userInfoResponse);
      }),
    );
  }

  private transformUserInfoResponse(
    userInfoResponse: UserInfoResponse,
  ): UserInfo {
    return {
      ...userInfoResponse,
    };
  }
}
